import { setNailsConfiguration } from '@reducers/selectors/dimension/actions';
import { setWoodConnectionNValue } from '@reducers/selectors/loads/actions';
import Scene from '@scene';

export const SET_NAIL_OPTIONS = 'SET_NAIL_OPTIONS';
export const RESET_NAIL = 'RESET_NAIL';
export const SET_NAIL_STATE = 'SET_NAIL_STATE';

/*
  Action creators
 */

export function setNailOptions(options) {
  return (dispatch, getState) => {
    dispatch(setNailsConfiguration(options));
    dispatch(triggerUpdate({ type: SET_NAIL_OPTIONS, options}));

    if (options.n || options.p) {
      let n = options.n || getState().options.nail.n;
      let p = options.p || getState().options.nail.p;
      dispatch(setWoodConnectionNValue(Math.ceil(n * p * 40 / 100)));
    }
  };
}

export function resetNail() {
  return triggerUpdate({ type: RESET_NAIL });
}

export function setNailState(state) {
  return { type: SET_NAIL_STATE, state };
}

function triggerUpdate(event) {
  return (dispatch, getState) => {
    dispatch(event);
    Scene.updateNail(getState().options.nail);
  };
}



// WEBPACK FOOTER //
// ./src/reducers/options/nail/actions.js